import { render, staticRenderFns } from "./configContentSelectProduct.vue?vue&type=template&id=31a5308e&scoped=true"
import script from "./configContentSelectProduct.vue?vue&type=script&lang=js"
export * from "./configContentSelectProduct.vue?vue&type=script&lang=js"
import style0 from "./configContentSelectProduct.vue?vue&type=style&index=0&id=31a5308e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5308e",
  null
  
)

export default component.exports